import { render, staticRenderFns } from "./User-space-pending.vue?vue&type=template&id=616ce163&scoped=true&"
import script from "./User-space-pending.vue?vue&type=script&lang=js&"
export * from "./User-space-pending.vue?vue&type=script&lang=js&"
import style0 from "./User-space-pending.vue?vue&type=style&index=0&id=616ce163&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616ce163",
  null
  
)

export default component.exports